<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-lg">

                    <h3>{{ title }}</h3>
                </div>
                <div class="col-lg-auto">
                    <button class="btn btn-outline-secondary"
                            v-on:click="addAdditionalItem()"
                            type="button">Dodaj
                    </button>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="form-group  ">

                <div v-for="(newField,index) in newAdditionalFields">
                    <div class="row">

                        <div class="col-lg">
                            <label class="w-100">
                                Nazwa
                                <input type="text"
                                       class="form-control"
                                       @change="emitChange"
                                       required
                                       v-model="newField.name"/>

                            </label>

                        </div>
                        <div class="col-lg-2">
                            <label class="w-100">
                                Podpowiedź
                                <input type="text"
                                       class="form-control"
                                       @change="emitChange"

                                       v-model="newField.placeholder"/>

                            </label>

                        </div>

                        <div class="col-lg-2">
                            <label class="w-100">
                                Typ
                                <select v-model="newField.type"
                                        class="form-control">
                                    <option value="text">Tekst</option>
                                    <option value="number">Liczba</option>
                                </select>
                            </label>
                        </div>
                        <div class="col-lg-2">
                            <label class="">
                                Czy wymagane?
                                <input type="checkbox"
                                       class="form-control"
                                       @change="emitChange"
                                       v-model="newField.required"/>

                            </label>
                        </div>

                        <div class="col-lg-auto pt-4">
                            <button type="button"
                                    @click="removeAdditionalField(newField)"
                                    class="btn btn-sm btn-outline-danger">Usuń
                            </button>

                        </div>

                    </div>
                    <hr>
                </div>
            </div>
        </div>
        <input type="hidden"
               name="additional_fields"
               v-bind:value="JSON.stringify(newAdditionalFields)">
    </div>
</template>

<script>

import {onBeforeMount, ref, watch} from 'vue';
import {snakeCase} from "lodash";

export default {
    name: 'DocumentTypesAdditionalFields',
    data: function () {
        return {
            newAdditionalFields: []
        }
    },
    props: {
        title: {
            type: String,
            default: 'Dodatkowe pola'
        },
        additionalFields: {
            type: Array,
            required: true
        },
    },
    setup(props, {emit}) {
        console.log(props.additionalFields);
        const newAdditionalFields = ref(props.additionalFields);

        const myChangeEvent = (newField, val) => {
            newField.additional_field_id = val;
        };

        const addAdditionalItem = () => {
            newAdditionalFields.value.push({
                name: '',
                placeholder: '',
                type: 'text',
                required: true
            });
            emitChange();
        };

        const removeAdditionalField = (field) => {
            const index = newAdditionalFields.value.indexOf(field);
            if (index > -1) {
                newAdditionalFields.value.splice(index, 1);
            }
            console.log(newAdditionalFields.value);
            emitChange();
        };

        const emitChange = () => {
            emit('fieldsChanged', newAdditionalFields.value);
        };
        // Watch for changes in the `name` field and generate a slug
        watch(
            newAdditionalFields,
            (fields) => {
                fields.forEach((field) => {
                    if (field.name) {
                        field.slug = snakeCase(field.name);
                    }
                });
            },
            {deep: true}
        );
        onBeforeMount(() => {
            newAdditionalFields.value = props.additionalFields;
        });

        return {
            newAdditionalFields,
            myChangeEvent,
            addAdditionalItem,
            removeAdditionalField,
            emitChange
        };
    }
}
</script>
